import React, { useState } from "react";
import "../UseCases.scss";
import { useCases } from "./useCasec.js";
import UseCaseComponent from "./useCaseComponent.js";
const UseCases = () => {
  const [pageNumber, setPageNumber] = useState(0);
  const Item = useCases[pageNumber];
  const selected = {
    borderBottom: pageNumber === 0 ? "3px solid #f0998d" : null,
  };
  return (
    <div id="useCases" className="UseCasesPage">
      <div>
        <ul className="useCasesNavbar">
          <li style={selected} onClick={() => setPageNumber(0)}>
            create
          </li>
          <li onClick={() => setPageNumber(1)}>manage</li>
          <li onClick={() => setPageNumber(2)}>automate</li>
          <li onClick={() => setPageNumber(3)}>chat</li>
        </ul>
      </div>
      <UseCaseComponent item={Item} />
    </div>
  );
};

export default UseCases;
